import AudienceCreation from './AudienceCreation.vue'
import { RouteRecordRaw } from 'vue-router'

const audiencCreationRoute: RouteRecordRaw = {
  name: 'audienceCreation',
  path: 'audience/create',
  component: AudienceCreation,
  meta: {
    requireAuth: true,
    title: 'Audience creation'
  }
}

export default audiencCreationRoute
